<template>
  <div class="form-group" :class="{ 'has-error': failingValidation }">
    <div class="col-md-4" :class="{ 'has-helper': helper }" v-if="label">
      <label class="control-label">
        {{ label }}: <span v-if="required">*</span>
      </label>
      <p class="help-block" v-text="helper" v-if="helper"></p>
    </div>
    <div
      class="control-container"
      :class="{ 'col-md-8': label, 'col-12': !label }"
    >
      <div class="input-group">
        <div class="input-group-append">
          <span class="input-group-text">&pound;</span>
        </div>

        <input
          type="number"
          v-on:blur="setActualValue($event.target.value)"
          class="form-control"
          :name="name"
          :value="formattedValue"
          :readonly="readonly"
          :disabled="readonly"
        />
      </div>

      <p class="help-block" v-if="failingValidation">
        The value cannot be more than {{ max | currency('£', false) }}
      </p>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    helper: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      actualValue: null
    };
  },

  computed: {
    formattedValue() {
      if (typeof this.actualValue === 'number') {
        return this.penceToPounds(this.actualValue);
      }

      return '';
    },

    failingValidation() {
      if (this.max !== null && this.actualValue > this.max) {
        return true;
      }

      return false;
    }
  },

  methods: {
    setActualValue(newValue) {
      this.actualValue = parseInt(this.poundsToPence(newValue));

      this.$emit('input', this.actualValue);
    }
  },

  watch: {
    value: {
      handler(value) {
        if (typeof value === 'number') {
          this.actualValue = parseInt(value);
        } else if (value === null) {
          this.actualValue = null;
        }
      },
      immediate: true
    }
  }
};
</script>
